const initialState = {};

export const sellerDashboard = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SELLER_DASHBOARD_ITEM":
      return { details: action.payload };
    default:
      return state;
  }
};
